/* eslint-disable @typescript-eslint/no-unused-vars */
import { useLazyQuery } from '@apollo/client'
import { CircularProgress, Collapse, Paper } from '@material-ui/core'
import React, { useState, useEffect } from 'react'
import InfiniteScroll from 'react-infinite-scroller'
import { toast } from 'react-toastify'

import { DateObject } from '../../helpers/date'
import { Channel } from '../../types/channel'
import { Currency } from '../../types/currency'
import {
  RoomTypeForInventory,
  ChannelInventoryData,
  RatePlanForInventory,
  GetInventoryInput,
  MenuItemInInventory
} from '../../types/inventory'
import InventoryProviderBox from './InventoryProviderBox'
import InventoryRatePlanRow from './InventoryRateplanRow'
import InventoryRatePlanSelectionModal from './InventoryRateplanSelectionModal'
import InventoryRoomtypeRow from './InventoryRoomtypeRow'
import { percentIncreaseDecreaseRegex } from './renderRows/RenderInputRowCell'
import useStyles from './styles/InventoryRoomtypeBox.styles'

interface InventoryRoomtypeBoxProps {
  roomData: RoomTypeForInventory
  weekendIndexes: number[]
  channels: Channel[]
  occupancy: number | 'def'
  hideZeroes: boolean
  range: 'TWO_WEEKS' | 'MONTH'
  getInventoryInput: GetInventoryInput
  refreshInventory: () => void

  // onSaveRoomData: (roomData: SingleRoomTypeData) => void
  // ChannelInventory:
  //   | {
  //       channelInventory: ChannelInventoryData
  //     }
  //   | undefined
}

const PAGE_SIZE = 10

const InventoryRoomtypeBox: React.FC<InventoryRoomtypeBoxProps> = ({
  roomData,
  weekendIndexes,
  channels,
  occupancy,
  hideZeroes,
  range,
  getInventoryInput,
  refreshInventory
  // ChannelInventory
  // onSaveRoomData
}) => {
  const classes = useStyles()
  // const [
  //   selectedInventoryFieldInRatePlan,
  //   setselectedInventoryFieldInRatePlan
  // ] = useState<MenuItemInInventory>({ label: 'price', code: 'price' })
  // const [selectedInventoryFieldInChannel, setselectedInventoryFieldInChannel] =
  //   useState<MenuItemInInventory>({ label: 'price', code: 'price' })
  // const [ratePlanSelectionModalIsOpen, setratePlanSelectionModalIsOpen] =
  //   useState(false)

  const [showProviders, setshowProviders] = useState(false)

  const [numberOfVisibleRatePlans, setnumberOfVisibleRatePlans] =
    useState(PAGE_SIZE)
  // const [selectedRatePlanIndex, setselectedRatePlanIndex] = useState<number>(-1)
  const [
    selectedInventoryFieldInProvider,
    setselectedInventoryFieldInProvider
  ] = useState<MenuItemInInventory>({
    label: 'availability',
    code: 'availability',
    type: 'number'
  })
  const handleChangeSelectedInventoryFieldInProvider = (
    fieldType: MenuItemInInventory
  ) => {
    setselectedInventoryFieldInProvider(fieldType)
  }

  // const handleChangeSelectedInventoryFieldInRatePlan = (
  //   fieldType: MenuItemInInventory
  // ) => {
  //   setselectedInventoryFieldInRatePlan(fieldType)

  // if (
  //   Object.keys(roomData.rateplans[0].channels[0]).includes(
  //     fieldType as string
  //   )
  // ) {
  //   setselectedInventoryFieldInChannel(
  //     fieldType as InventoryChannelFieldsType
  //   )
  // }
  // }

  // const handleChangeSelectedInventoryFieldInChannel = (
  //   fieldType: MenuItemInInventory
  // ) => {
  //   setselectedInventoryFieldInChannel(fieldType)
  // if (Object.keys(roomData.rateplans[0]).includes(fieldType as string)) {
  //   setselectedInventoryFieldInRatePlan(
  //     fieldType as InventoryRatePlanFieldsType
  //   )
  // }
  // }

  // const handleChangeRatePlanRowData = (
  //   ratePlanNewRowData: InventoryRateplanType,
  //   index: number
  // ) => {
  //   const newRatePlansRowsData = roomData.rateplans
  //   newRatePlansRowsData[index] = ratePlanNewRowData
  //   onSaveRoomData({
  //     ...roomData,
  //     rateplans: newRatePlansRowsData
  //   })
  // }

  // const handleCopyRatePlanRowForOtherRatePlans = (
  //   index: number,
  //   selectedRatePlans: string[]
  // ) => {
  //   const newRoomData = roomData
  //   for (let i = 0; i < newRoomData.rateplans.length; i += 1) {
  //     if (
  //       i === index ||
  //       !selectedRatePlans.includes(newRoomData.rateplans[i].name)
  //     ) {
  //       // eslint-disable-next-line no-continue
  //       continue
  //     }
  //     for (
  //       let j = 0;
  //       j < newRoomData.rateplans[i][selectedInventoryFieldInRatePlan].length;
  //       j += 1
  //     ) {
  //       if (
  //         selectedInventoryFieldInRatePlan !== 'name' &&
  //         selectedInventoryFieldInRatePlan !== 'channels' &&
  //         newRoomData.rateplans[index][selectedInventoryFieldInRatePlan][j]
  //           .edited
  //       ) {
  //         const regexEdited =
  //           newRoomData.rateplans[index][selectedInventoryFieldInRatePlan][j]
  //             .editedValue &&
  //           percentIncreaseDecreaseRegex.test(
  //             newRoomData.rateplans[index][selectedInventoryFieldInRatePlan][j]
  //               .editedValue || ''
  //           )
  //         let newValue =
  //           newRoomData.rateplans[index][selectedInventoryFieldInRatePlan][j]
  //             .value

  //         if (regexEdited) {
  //           newValue =
  //             (newRoomData.rateplans[i][selectedInventoryFieldInRatePlan][j]
  //               .value as number) +
  //             (newRoomData.rateplans[i][selectedInventoryFieldInRatePlan][j]
  //               .value as number) *
  //               (Number(
  //                 newRoomData.rateplans[index][
  //                   selectedInventoryFieldInRatePlan
  //                 ][j].editedValue!.substring(
  //                   1,
  //                   newRoomData.rateplans[index][
  //                     selectedInventoryFieldInRatePlan
  //                   ][j].editedValue!.length - 1
  //                 )
  //               ) /
  //                 100) *
  //               (newRoomData.rateplans[index][selectedInventoryFieldInRatePlan][
  //                 j
  //               ].editedValue!.charAt(0) === '+'
  //                 ? 1
  //                 : -1)
  //         }
  //         newRoomData.rateplans[i][selectedInventoryFieldInRatePlan][j] = {
  //           ...newRoomData.rateplans[i][selectedInventoryFieldInRatePlan][j],
  //           edited: true,
  //           value: newValue,
  //           // eslint-disable-next-line no-nested-ternary
  //           editedValue: regexEdited
  //             ? newRoomData.rateplans[index][selectedInventoryFieldInRatePlan][
  //                 j
  //               ].editedValue
  //             : typeof newValue === 'boolean'
  //             ? undefined
  //             : newValue.toString()
  //         }
  //       }
  //     }
  //   }
  //   onSaveRoomData({
  //     ...newRoomData,
  //     rateplans: [
  //       ...newRoomData.rateplans.map((singleRatePlan) => ({
  //         ...singleRatePlan
  //       }))
  //     ]
  //   })
  // }

  useEffect(() => {
    setshowProviders(false)
  }, [range])

  return (
    <Paper className={classes.paper} elevation={5}>
      <div>
        <InventoryRoomtypeRow
          name={`${roomData?.basicDetails.name} (${roomData.basicDetails.displayRoomTypeCode})`}
          numberOfProviders={roomData?.basicDetails.providers.length}
          {...{ showProviders, setshowProviders, range, weekendIndexes }}
        />
        <Collapse in={showProviders}>
          <div>
            <InfiniteScroll
              pageStart={0}
              loadMore={() => {
                setTimeout(() => {
                  setnumberOfVisibleRatePlans(
                    numberOfVisibleRatePlans + PAGE_SIZE
                  )
                }, 500)
              }}
              hasMore={
                roomData &&
                numberOfVisibleRatePlans <
                  roomData.basicDetails.providers.length - 1
              }
              loader={
                <div key={0} className={classes.loadingContainer}>
                  <CircularProgress size={32} />
                </div>
              }
              useWindow={true}>
              {roomData?.basicDetails.providers
                .slice(0, numberOfVisibleRatePlans)
                .map((providerItem, index) => (
                  <InventoryProviderBox
                    key={index}
                    {...{
                      weekendIndexes,
                      hideZeroes,
                      range,
                      occupancy,
                      getInventoryInput,
                      channels,
                      handleChangeSelectedInventoryFieldInProvider,
                      selectedInventoryFieldInProvider,
                      refreshInventory
                    }}
                    defaultOccupancy={roomData.basicDetails.defaultOccupancy}
                    numberOfRooms={roomData.basicDetails.numberOfRooms}
                    providerData={providerItem}
                    roomtypeCode={roomData.basicDetails.roomTypeCode}
                    // onSaveRowData={(newRowData) =>
                    //   handleChangeRatePlanRowData(newRowData, index)
                    // }
                    // onCopyRatePlanForOtherRatePlans={
                    //   () => {
                    //     setratePlanSelectionModalIsOpen(true)
                    //     setselectedRatePlanIndex(index)
                    //   }
                    // handleCopyRatePlanRowForOtherRatePlans(index)
                    // }
                  />
                ))}
            </InfiniteScroll>
          </div>
        </Collapse>
      </div>
      {/* {ratePlanSelectionModalIsOpen && (
        <InventoryRatePlanSelectionModal
          onClose={() => setratePlanSelectionModalIsOpen(false)}
          onConfirm={(selectedRatePlans) => {
            setratePlanSelectionModalIsOpen(false)
            handleCopyRatePlanRowForOtherRatePlans(
              selectedRatePlanIndex,
              selectedRatePlans
            )
          }}
          ratePlans={roomData.rateplans
            .filter((item, index) => index !== selectedRatePlanIndex)
            .map((item) => item.name)}
        />
      )} */}
    </Paper>
  )
}

export default InventoryRoomtypeBox
